<template>
  <div class="u-wrap">
    <van-form>
      <u-xzzz :required="true" label="现居住地" v-model="model.sysOrgCode"></u-xzzz>
      <van-field v-model="model.address" label="详细地址" placeholder="请输入详细地址" input-align="right" />
    </van-form>
    <div class="b-btn">
      <button class="b-button" :disabled="isValidate" @click="clickSumbit">提交</button>
    </div>
  </div>
</template>

<script>
import { getAction, putAction } from '@/api/manage'
import { WX_USER } from '@/store/mutation-types'
import Vue from 'vue'
import uXzzz from '../../components/page/u-xzzz.vue'
export default {
  components: { uXzzz },
  data() {
    return {
      model: {
        sysOrgCode: '',
        address: '',
        sysOrgCode_dictText: '',
        openId: '',
      },
      content: '',
    }
  },
  created() {
    let object = Vue.ls.get(WX_USER, {})
    if (object) {
      this.model.sysOrgCode = object.sysOrgCode
      this.model.address = object.address
      this.model.openId = object.openId
    }
  },
  computed: {
    isValidate() {
      let validate = true
      if (this.model.sysOrgCode) {
        validate = false
      }

      return validate
    },
  },
  methods: {
    clickSumbit() {
      putAction('/sys/detectauth/update', this.model).then((res) => {
        if (res.success) {
          this.sxRzInfo()
          this.$router.replace({
            name: 'success',
            params: {
              isBack: true,
              title: '修改成功',
            },
          })
        }
      })
    },
    sxRzInfo() {
      let openId = this.$store.getters.openId
      let params = { openId: openId }
      let url = '/sys/mlogin/wx/login/userinfo'
      getAction(url, params).then((res) => {
        if (res.success) {
          let obj = res.result
          if (obj) {
            let wxInfo = obj.SysUserWechatBind[0]
            Vue.ls.set(WX_USER, wxInfo)
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f5f5f5;
}
* {
  box-sizing: border-box;
}
.u-wrap /deep/ .van-button--primary {
  background-color: #3f8ffb;
  border: 1px solid #3f8ffb;
}

.b-btn {
  margin-top: 20px;
  padding: 0 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}
</style>
